import React from "react";
import { COLORS, RADIUS } from "../../theme";

export default function Modal({ open, onClose, title, children, width = 440 }) {
  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(16,26,61,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 100,
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: COLORS.surface,
          borderRadius: RADIUS.xl,
          padding: 28,
          width: "100%",
          maxWidth: width,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(16,26,61,0.25)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <h3 style={{ fontSize: 18, fontWeight: 800, color: COLORS.text, margin: 0, letterSpacing: "-0.02em" }}>
            {title}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: COLORS.gray,
              border: "none",
              borderRadius: 8,
              width: 28,
              height: 28,
              fontSize: 15,
              color: COLORS.textMid,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
